const shareModal = {

	shareOptions: {
		facebook: {
			title: 'Share on Facebook',
			label: 'Share',
			url: 'https://facebook.com/sharer/sharer.php?u=%u',
			color: '3b5998'
		},
		twitter: {
			title: 'Tweet on Twitter',
			label: 'Tweet',
			url: 'https://twitter.com/intent/tweet?text=%m',
			color: '1da1f2'
		},
		reddit: {
			title: 'Share on Reddit',
			label: 'Share',
			url: 'https://reddit.com/submit?url=%u',
			color: 'ff4500'
		},
		tumblr: {
			title: 'Share on Tumblr',
			label: 'Share',
			url: 'https://tumblr.com/widgets/share/tool?canonicalUrl=%u&content=%m',
			color: '35465c'
		},
		email: {
			title: 'Send via Email',
			label: 'Send',
			url: 'mailto:somebody@example.com?body=%m',
			color: '483d8b'
		}
	},

	/**
	 * The message to share.
	 * The following placeholders can be used:
	 * %s will be replaced with the current url.
	 * %u will be replaced with the current url.
	 * %m will be replaced with the message.
	 */
	message: 'I just created some cool art with Brush Ninja! 🎨🖌️ It\'s a fun and easy-to-use tool that works right in your browser. No sign up needed. Start Creating! %s',

	/**
	 * The url to share.
	 */
	shareUrl: '',


	/**
	 *
	 */
	show: function( title = 'Saved', content = '' ) {

		const share_m = modal.showGeneral( title );

		share_m.innerHTML = shareModal.template( content );

		// Generate the share url.
		shareModal.setUrl();

	},


	/**
	 * The share template.
	 *
	 * @param {string} content
	 * @return {string}
	 */
	template: function( content = '', closeButton = true ) {

		if ( content.length ) {
			content = `<div class="f4 m-y4 f-fw700">${content}</div>`;
		}

		shareModal.setUrl();

		let shareButtons = '';

		// Loop through shareModal.shareOptions and create javascript links
		Object.keys( shareModal.shareOptions ).forEach(
			function( shareOption ) {

				const share = shareModal.shareOptions[ shareOption ];

				const styles = [
					'-webkit-mask: center no-repeat;',
					'mask: center no-repeat;',
					'-webkit-mask-size: contain;',
					'mask-size: contain;',
					`-webkit-mask-image: url(/assets/images/social/${shareOption.toLowerCase()}.svg);`,
					`mask-image: url(/assets/images/social/${shareOption.toLowerCase()}.svg);`,
					'background: white;',
					'width: 1.5rem;',
					'height: 1.5rem;',
				];

				shareButtons += `
				<a
					class="bg-${shareOption} f-fw700 p2 b-br1 flex-g1 flex flex-jc-c flex-ai-c"
					style="background: #${share.color}; color: #fff;"
					href="${sanitize.attr( shareModal.processUrl( share.url ) )}"
					target="_blank"
					rel="noopener"
					title="${share.title}">
					<span class="icon-mask" style="${styles.join( ' ' )}"></span>
					<span class="screen-reader-text">${share.label}</span>
				</a>`;

			}
		);

		return `
			${content}
			<div class="bg-yellow b-br2 p4">
				<h2 class="f-fw700 m-y2 fg-black f4">Proud of your Brush Ninja creation?</h2>
				<p class="m-y2">Share it with your friends ⬇️</p>
				<div class="flex gap2 m-y3">${shareButtons}</div>
			</div>
			${closeButton ? '<button class="bg-blue f-fw700 m-t4" onclick="modal.close()">Create More &rarr;</button>' : ''}
		`;

		// <div class="b p2 b-br1 m-y3">${sanitize.html( shareModal.message.replace( '%s', window.location.href ) )}</div>

		// 	<div class="flex gap2 m-y4">
		// 	<input class="flex-g1 m0" value="${sanitize.url( window.location.href )}" readonly>
		// 	<button class="bg-blue f-fw700" onclick="shareModal.copyLink()">Copy url</button>
		// </div>

	},


	/**
	 * Process the url.
	 *
	 * @param {string} url
	 * @return {string}
	 */
	processUrl: function( url ) {

		shareModal.setUrl();

		const message = shareModal.message.replace( '%s', shareModal.shareUrl );

		url = url.replace( '%u', encodeURIComponent( shareModal.shareUrl ) );
		url = url.replace( '%m', encodeURIComponent( message ) );

		return url;

	},


	/**
	 * Generate the shareUrl value.
	 *
	 * @return {void}
	 */
	setUrl: function() {

		if ( shareModal.shareUrl.length ) {
			return;
		}

		// Get canonical url.
		const canonical = document.querySelector( 'link[rel="canonical"]' );

		if ( canonical ) {
			shareModal.shareUrl = canonical.href;
			return;
		}

		shareModal.shareUrl = window.location.href;

	},

};
